import React from "react";
import { Link } from "react-router-dom";
import { Error1, logobpom } from "../imagepath";

export const NotFound = () => {
   
  return (
    <>
      <div className="main-wrapper">
        <div className="container">
          <div className="row">
                <div className="col-lg-12">
                    <div className="error-box">
                        <div className="error-logo">
                            <Link to="/home">
                            <img src={logobpom} className="img-fluid" alt="Logo" />
                            </Link>
                        </div>
                        <div className="error-box-img">
                            <img src={Error1} alt="" className="img-fluid" />
                        </div>
                        <h3 className="h2 mb-3"> Oh No! Error 404</h3>
                        <p className="h4 font-weight-normal">
                            This page you requested counld not found. May the force be with you!
                        </p>
                        <Link to="/home" className="btn btn-primary">
                            Back to Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
